export const SOP_INSTANCE_UID = "00080018";
export const SERIES_INSTANCE_UID = "0020000E";
export const MODALITY = "00080060";
export const PET_SERIES_TYPE = "00541000";
export const FRAME_REFENCE_TIME = "00541300";
export const IMAGE_POSITION_PATIENT = "00200032";
export const IMAGE_ORIENTATION_PATIENT = "00200037";
export const REFERENCED_SERIES_SEQUENCE = "00081115";